import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

const ExternallyArrangedTitle: FC = () => (
    <FormattedMessage
        id="checkout.ExternallyArrangedTitle.title"
        defaultMessage="Arrange shipping yourself"
    />
);

export default ExternallyArrangedTitle;
